import { NgModule } from '@angular/core';
import { SpaqDatePipe } from './date.pipe';
import { SpaqTimestampPipe } from './timestamp.pipe';

const PIPES = [SpaqDatePipe, SpaqTimestampPipe];

@NgModule({
	declarations: PIPES,
	exports: PIPES
})
export class DateModule {}
